import { actions } from 'data'
import { notifyError } from 'data/App/sagas'
import { call, put, takeEvery } from 'redux-saga/effects'
import { signMarginAgreement } from 'services/api/margin'

const sign = function* () {
  const { error } = yield call(signMarginAgreement)
  if (error) {
    yield put(actions.margin.signError())
    yield call(notifyError, error.cause, 'KO_GENERIC')
    return
  }

  yield put(actions.margin.signed())
}

const marginSagas = function* () {
  yield takeEvery(actions.margin.sign.type, sign)
}

export default marginSagas
